import Grid from "@mui/material/Unstable_Grid2";
import React, { useCallback } from "react";
import { Button, Box, Link, Modal } from "@mui/material";
import "../../OrganisationSettings/Currencies/Currencies.scss";
import { useNavigate } from "react-router-dom";

import UGTable from "../../../../../../Supporting files/UGTable/UGTable";
// import AddCurrency from "./AddCurrency";

const AccessControl = () => {
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const navigate = useNavigate();

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "roleid",
      headerName: "Role ID",
      width: 200,
      check_status: true,
    },
    {
      field: "role",
      headerName: "Role",
      width: 250,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <p
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/EditCreateRole");
            }}
          >
            Admin
          </p>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 250,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return <span className={row.status}>{row.status}</span>;
      },
    },
    {
      field: "date",
      headerName: "Date",
      width: 200,
      check_status: true,
    },
    {
      field: "time",
      headerName: "Time",
      width: 200,
      check_status: true,
    },
    {
      field: "assignedusers",
      headerName: "Assigned Users",
      width: 200,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      roleid: "EV001",
      role: "Admin",
      status: "Pending",
      date: "22 - Mar- 2023",
      time: "15:00 hrs",
      assignedusers: "14",
    },
    {
      id: 1,
      roleid: "EV002",
      role: "Agent",
      status: "Active",
      date: "22 - Mar- 2023",
      time: "15:00 hrs",
      assignedusers: "15",
    },
    {
      id: 2,
      roleid: "EV003",
      role: "Super - Admin",
      status: "Rejected",
      date: "22 - Mar- 2023",
      time: "15:00 hrs",
      assignedusers: "12",
    },
    {
      id: 3,
      roleid: "EV004",
      role: "Manager",
      status: "Inprogress",
      date: "22 - Mar- 2023",
      time: "15:00 hrs",
      assignedusers: "18",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <Grid container spacing={2} className="currunciesWrapper">
      <Grid xs={4}>
        <h3 className="mb-0">Access Control</h3>
      </Grid>

      <Grid xs={8} className="text-right">
        <div className="buttons">
          <Link
            underline="none"
            className="greenBtn addfile"
            onClick={() => {
              navigate("/CreateRole");
            }}
          >
            Create
          </Link>
          <Link
            underline="none"
            className="blueBtn edit"
            onClick={() => {
              navigate("/EditCreateRole");
            }}
          >
            Edit
          </Link>
          <Link
            underline="none"
            className="redBtn delete"
            onClick={() => {
              setDeleteStatus(true);
            }}
          >
            Remove
          </Link>
        </div>
      </Grid>
      <Grid xs={12}>
        <div style={{ height: 400 }}>
          <UGTable
            header_data={columns}
            data={rows}
            value_update={updateMasterState}
            attrName={"UGTable"}
          />
        </div>
      </Grid>
      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are want to delete 5 Users.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
};

export default AccessControl;
